import { useTranslations } from '@vocab/react';
import { Box, Text, Stack, Strong } from 'braid-design-system';

import translations from './.vocab';

export const NoSearchResults = () => {
  const { t } = useTranslations(translations);

  return (
    <Box padding="xxlarge" maxWidth="small" style={{ margin: '0 auto' }}>
      <Stack space="medium" align="center">
        <Text align="center">
          <Strong>{t('NO_MATCHING_PROFILES')}</Strong>
        </Text>
        <Text align="center" tone="secondary">
          {t('COULD_NOT_FIND_ANY_PROFILES_THAT_MATCHED_YOUR_SEARCH')}
        </Text>
      </Stack>
    </Box>
  );
};
